export const addPublicURL = (url: string): string => {
  if (process.env.REACT_APP_NODE_ENV === 'production') {
    return `${process.env.REACT_APP_PUBLIC_URL}${url}`;
  }
  return url;
};
